import { createAsyncAction } from "./utils";
export var updateDebtOnboardingProfile = createAsyncAction('updateDebtOnboardingProfile', function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      identityId = _ref.identityId,
      updatedProfile = _ref.updatedProfile,
      _ref$serverRequest = _ref.serverRequest,
      serverRequest = _ref$serverRequest === void 0 ? false : _ref$serverRequest;

  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.DebtSDK.updateOnboardingProfile(identityId, updatedProfile, serverRequest);
    }
  };
});